module.exports = __webpack_public_path__ + "media/images/athletes/1882-47fb6c3e40a1b8bb43867c1046d6cf28.png";